import {FlexibleHourVI} from "./flexible-hour/vi";
import {InoutVI} from "./inout/vi";
import {LeaveVI} from "./leave/vi";
import {MissionVI} from "./mission/vi";
import {MissionFeeVI} from "./mission-fee/vi";
import {MissionVehicleVI} from "./mission-vehicle/vi";
import {ResignVI} from "./resign/vi";
import {GeneralSettingsVI} from "./general/vi";

export const ApplicationSettingVI = {
    "reason": {
        "sider": "Lý do",
        "title": {
            "delete": "Bạn có muốn xóa lý do?"
        },
        "placeholder": {
            "name": "Nhập lý do",
            "quota": "Lần",
            "minimum": "",
            "unit": "",
            "inout": "",
            "paid": "",
            "state": "",
            "fine": "",
            "feeAmount": "",
            "earlyOut": "hh:mm",
            "lateIn": "hh:mm",
            "total": "hh:mm",
            "code": "Kí hiệu",
            "order": "Thứ tự"
        },
        "option": {
            "yes": "Có",
            "no": "Không",
            "time_per_week": "Lần/Tuần",
            "time_per_month": "Lần/Tháng",
            "day_per_week": "Ngày/Tuần",
            "day_per_month": "Ngày/Tháng",
            "day_per_year": "Ngày/Năm",
            "actived": "Hoạt động",
            "inactived": "Không hoạt động"
        },
        "column": {
            "name": "Nhập lý do",
            "quota": "Tối đa",
            "minimum": "Tối thiểu",
            "unit": "Đơn vị",
            "inout": "Yêu cầu chốt",
            "paid": "Tính công",
            "state": "Trạng thái",
            "fine": "Phạt tiền",
            "feeAmount": "Phí công tác",
            "earlyOut": "Về sớm",
            "lateIn": "Đi muộn",
            "total": "Tổng",
            "code": "Kí hiệu",
            "order": "Thứ tự"

        },
    },
    ...FlexibleHourVI,
    ...InoutVI,
    ...LeaveVI,
    ...MissionVI,
    ...MissionFeeVI,
    ...MissionVehicleVI,
    ...ResignVI,
    ...GeneralSettingsVI
}